import { Flex, Box, Image, Text } from "@chakra-ui/react"
import { useReservationsContext } from "providers/ReservationsProvider/ReservationsProvider"

import { useUI } from "providers/UIProvider"

const ReservationDetailsCompany: React.FC = () => {
  const { T } = useUI()
  const { currentReservation: reservation } = useReservationsContext()

  return (
    <Flex
      padding="16px 23px"
      justifyContent="space-between"
      borderBottom="1px solid #E9F2FD"
      width="100%"
      alignItems="center"
      mb="30px"
      height="50px"
    >
      <Box w="50%"><Text fontSize="12px">{T("booking.details.modal.booking.laundry")}</Text></Box>
      <Flex
        w="50%"
        justifyContent="flex-end"
        alignItems="center"
      >
        <Image src={reservation?.carWashLogoUrl || ""} w="20%" height="auto" />
        <Text ml="10px" fontWeight="bold" fontSize="base">{reservation?.carWashAddress}</Text>
      </Flex>
    </Flex>
  )
}

export default ReservationDetailsCompany